import {
  FaceRetouchingNaturalIcon,
  SupervisorAccountIcon,
  StackedBarChartIcon,
  MobileScreenShareIcon,
  SettingsIcon,
  AllInboxIcon,
  NotificationsNoneIcon,
} from '@assets/icons';
import { useAppDispatch, useAppSelector, useNotificationSocket } from '@hooks';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Routes } from '@utils/constants';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Drawer } from './Menu.styled';
import { useLocation } from 'react-router-dom';

import './Menu.scss';
import { USER_ROLE } from '@utils/constants/enums';
import { getNotificationUnconfirmedCountAsync } from '@redux/actions/apiActions/notificationApiAction';

const MenuItem: IMenuItem[] = [
  {
    route: Routes.DASHBOARD,
    text: 'common.dashboard',
    icon: StackedBarChartIcon,
  },
  {
    route: Routes.PRE_REGISTRATION_LIST,
    text: 'pre_registration_list.title',
    icon: MobileScreenShareIcon,
  },
  {
    route: Routes.DRIVER_MANAGEMENT,
    text: 'driver_management.list_driver_history',
    icon: SupervisorAccountIcon,
  },
  {
    route: Routes.RECEPTION_HISTORY,
    text: 'history_driver_management.history_driver',
    icon: FaceRetouchingNaturalIcon,
  },
  {
    route: Routes.NOTIFICATION_LIST,
    text: 'notification.notification_list',
    icon: NotificationsNoneIcon,
  },
  {
    route: Routes.SECURITY_BOX,
    text: 'security_box.title',
    icon: AllInboxIcon,
  },
  {
    route: Routes.SYSTEM_CONFIGURATION,
    text: 'setting.setting_list.title',
    icon: SettingsIcon,
    roles: [USER_ROLE.ADMIN],
  },
];

const Menu: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const unreadNotificationCount = useAppSelector(
    state => state.notificationList.unreadCount
  );
  const { t } = useTranslation();
  const { openMenu } = useAppSelector(state => state.app);
  const { user } = useAppSelector(state => state.auth);

  const currentRole = user.role;

  const handleClick = (item: IMenuItem) => () => {
    if (location.pathname !== item.route) {
      navigate(item.route);
    }
  };

  const filteredMenu = MenuItem.filter(
    menu => !menu.roles || menu.roles.includes(currentRole)
  );

  const handleGetCountNotification = async () => {
    try {
      await dispatch(getNotificationUnconfirmedCountAsync());
    } catch {
      // empty
    }
  };

  useNotificationSocket(async () => {
    await handleGetCountNotification();
  });

  return (
    <Drawer variant='permanent' open={openMenu} className='Menu'>
      <List className='Menu__list' disablePadding>
        {filteredMenu.map(item => (
          <ListItem key={item.route} disablePadding className='MenuItem'>
            <ListItemButton
              className='MenuItem__content'
              sx={{ justifyContent: openMenu ? 'initial' : 'center' }}
              selected={location.pathname.includes(item.route)}
              onClick={handleClick(item)}
            >
              <ListItemIcon
                className='MenuItem__content__icon'
                sx={{ mr: openMenu ? 3 : 'auto' }}
              >
                <item.icon />
              </ListItemIcon>
              <ListItemText
                className='MenuItem__text'
                primary={
                  <Box className='MenuItem__wrapper'>
                    {t(item.text)}
                    {item.route === Routes.NOTIFICATION_LIST &&
                      unreadNotificationCount > 0 && (
                        <Box className='MenuItem__badge'>
                          {unreadNotificationCount}
                        </Box>
                      )}
                  </Box>
                }
                sx={{ opacity: openMenu ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Menu;
